import React, { PureComponent } from 'react';
import TextField from './text-field';
import PhoneField from './phone-field';
import { validators } from 'ui-validator';
import ActionArea from './action-area';
import BackButton from './back-button';
import FillMe from './fill-me';
import Randoms from '../lib/randoms';
import { validNameKey, handleOnPasteForNameField } from '../lib/valid-key';
import Spinner from './spinner';

class ContactInformation extends PureComponent {

  state = {
    disableAction: false
  }

  handleFirstNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('contactFirstname', value, {
      isRequired: true,
      fieldDisplayName: 'Contact first name'
    });
  }

  handleFirstNameBlur = (e) => {
    const { value } = e.target;
    const { actions: { enterFieldData }, errors } = this.props;
    enterFieldData('contactFirstname', value, {
      isRequired: errors.contactFirstname ? true : false,
      fieldDisplayName: 'Contact first name'
    });
  }

  handleLastNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('contactLastname', value, {
      isRequired: true,
      fieldDisplayName: 'Contact last name'
    });
  }

  handleLastNameBlur = (e) => {
    const { value } = e.target;
    const { actions: { enterFieldData }, errors } = this.props;
    enterFieldData('contactLastname', value, {
      isRequired: errors.contactLastname ? true : false,
      fieldDisplayName: 'Contact last name'
    });
  }

  handlePhoneChange = (e) => {
    const { actions: { enterPracticePhone }, errors } = this.props;
    const { target: { value } } = e;
    const runValidation = errors.practicePhone ? true : false;
    enterPracticePhone(value, runValidation);
  }

  handlePhoneBlur = (e) => {
    const { enterPracticePhone } = this.props.actions;
    const { target: { value } } = e;
    enterPracticePhone(value);
  }

  handleDoctorFirstNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('doctorFirstname', value, {
      isRequired: true,
      fieldDisplayName: 'Doctor first name'
    });
  }

  handleDoctorFirstNameBlur = (e) => {
    const { value } = e.target;
    const { actions: { enterFieldData }, errors } = this.props;
    enterFieldData('doctorFirstname', value, {
      isRequired: errors.doctorFirstName ? true : false,
      fieldDisplayName: 'Doctor first name'
    });
  }

  handleDoctorLastNameBlur= (e) => {
    const { value } = e.target;
    const { actions: { enterFieldData }, errors } = this.props;
    enterFieldData('doctorLastname', value, {
      isRequired: errors.doctorLastname ? true : false,
      fieldDisplayName: 'Doctor last name'
    });
  }

  handleDoctorLastNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('doctorLastname', value, {
      isRequired: true,
      fieldDisplayName: 'Doctor last name'
    });
  }

  handleDoctorEmailChange = (e) => {
    const { value } = e.target;
    const {
      actions: { enterDoctorEmail },
      errors,
      practice: { email: primaryEmail }
     } = this.props;
    const hasValidation = errors.doctorEmail ? true : false;
    enterDoctorEmail(value, primaryEmail, hasValidation);
  }

  handleDoctorEmailBlur = (e) => {
    const { value,   } = e.target;
    const { 
      practice: { email: primaryEmail },
      actions: { enterDoctorEmail }
    } = this.props;
    enterDoctorEmail(value, primaryEmail);
  }

  handleSubmit = () => {
    this.setState({
      disableAction: true
    }, () => {
      const {
        practice: { email: practiceEmail },
        actions: { submitContactInfo }
      } = this.props

      const validator = (email) => {
        const isEmailValid = validators.email({ message: 'A valid email address is required.' });
        if (email === practiceEmail) {
          return 'Doctor email cannot be the same as login email.';
        }
        return isEmailValid(email);
      };

      const fields = {
        required: [
          { name: 'practicePhone', displayName: 'Practice phone number' },
          { name: 'contactFirstname', displayName: 'Contact first name' },
          { name: 'contactLastname', displayName: 'Contact last name' },
          { name: 'doctorFirstname', displayName: 'Doctor first name' },
          { name: 'doctorLastname', displayName: 'Doctor last name' }
        ],
        optional: [
          { name: 'doctorEmail', validator }
        ]
      };

    submitContactInfo(this.props.practice, fields)
      .then((result) => {
        if (result) {
          if(result.hasError) {
            return this.setState({ disableAction: false });
          }
          if (result.capAlreadyReview) { return; }
        }

        const route = this.props.isInReview
          ? '/patientsolutions/enroll/review'
          : '/patientsolutions/enroll/practice-information';

        this.props.history.push(route);
      })
      .catch(({ response }) => {
        this.setState({ disableAction: false });
        const { data, status } = response;
        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }

        if (data && data.redirectTo) {
          window.location.href = data.redirectTo;
        }
      });
    });
  }

  handleFillMe = (e) => {
    const {
      enterFieldData,
      enterDoctorEmail
    } = this.props.actions;
    enterFieldData('contactFirstname', Randoms.randomPersonName('PC', 'FN'), {
      isRequired: true,
      fieldDisplayName: 'Contact first name'
    });
    enterFieldData('contactLastname', Randoms.randomPersonName('PC', 'LN'), {
      isRequired: true,
      fieldDisplayName: 'Contact last name'
    });
    enterFieldData('doctorFirstname', Randoms.randomPersonName('DOC', 'FN'), {
      isRequired: true,
      fieldDisplayName: 'Doctor first name'
    });
    enterFieldData('doctorLastname', Randoms.randomPersonName('DOC', 'LN'), {
      isRequired: true,
      fieldDisplayName: 'Doctor last name'
    });
    enterDoctorEmail(Randoms.randomEmail());
  }

  hasValidations = () => {
    const { errors } = this.props;
    return errors.contactFirstname
      || errors.contactLastname
      || errors.practicePhone
      || errors.doctorFirstname
      || errors.doctorLastname
      || errors.doctorEmail;
  }

  render() {
    const { contactFirstname, contactLastname, email } = this.props.practice;
    const { processingSubmit, hasCompletedReview } = this.props.onboarding;
    const { isInReview, actions, history } = this.props;
    const { disableAction } = this.state;

    const previousRoute = this.props.onboarding.previousRoute;

    const buttonProps = {
      className: 'button-submit-next',
      onSubmit: this.handleSubmit,
      isInReview,
      actions,
      history
    };

    if (disableAction && !this.hasValidations() || hasCompletedReview) {
      buttonProps.disabled = true;
    }

    return <section className="contact-information-section">
      { isInReview && <BackButton {...this.props} previousRoute={previousRoute} /> }
      <h1 className='section-title'>Enter your contact information</h1>
      <p>We will use your primary contact information to stay in touch with you. The Doctor information is listed on our website to help patients when searching for your practice.</p>

      <form>
        <div className='area'>
          <h2 className='area-title'>Primary Contact Information</h2>

          <TextField
            data-test-id="primary-contact-fname-field"
            aria-required
            className='input-helper'
            htmlFor='primary_contact_fname'
            inputClassName='txt-field-input-medium'
            labelText='First Name'
            labelClassName='section-label'
            defaultValue={contactFirstname}
            errorMsg={this.props.errors.contactFirstname}
            onChange={this.handleFirstNameChange}
            onBlur={this.handleFirstNameBlur}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
          />

          <TextField
            data-test-id="primary-contact-lname-field"
            aria-required
            className='input-helper'
            htmlFor='primary_contact_lname'
            inputClassName='txt-field-input-medium'
            labelText='Last Name'
            labelClassName='section-label'
            defaultValue={contactLastname}
            errorMsg={this.props.errors.contactLastname}
            onChange={this.handleLastNameChange}
            onBlur={this.handleLastNameBlur}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
          />

          <TextField
            data-test-id="primary-contact-email-field"
            aria-required
            className='input-helper'
            htmlFor='practice_login'
            inputClassName='txt-field-input-medium'
            labelText='Login Email'
            labelClassName='section-label'
            disabled
            defaultValue={email}
          />

          <PhoneField
            htmlFor='primary_practice_phone'
            inputClassName='txt-field-input-medium'
            labelText='Primary Contact Phone'
            labelClassName='section-label'
            className='input-helper'
            errorMsg={this.props.errors.practicePhone}
            onChange={this.handlePhoneChange}
            onBlur={this.handlePhoneBlur}
            defaultValue={this.props.practice.phone}
          />
        </div>

        <div className='area'>
          <a id='doctor-info'/>
          <h2 className='area-title'>Doctor Information</h2>

          <TextField
            data-test-id="doctor-fname-field"
            aria-required
            className='input-helper'
            htmlFor='doctor_contact_fname'
            inputClassName='txt-field-input-medium'
            labelText='First Name'
            labelClassName='section-label'
            errorMsg={this.props.errors.doctorFirstname}
            onBlur={this.handleDoctorFirstNameBlur}
            onChange={this.handleDoctorFirstNameChange}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
            defaultValue={this.props.practice.doctorFirstname}
          />

          <TextField
            data-test-id="doctor-lname-field"
            aria-required
            className='input-helper'
            htmlFor='doctor_contact_lname'
            inputClassName='txt-field-input-medium'
            labelText='Last Name'
            labelClassName='section-label'
            errorMsg={this.props.errors.doctorLastname}
            onBlur={this.handleDoctorLastNameChangeBlur}
            onChange={this.handleDoctorLastNameChange}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
            defaultValue={this.props.practice.doctorLastname}
          />

          <TextField
            data-test-id="doctor-email-field"
            aria-required
            className='input-helper'
            htmlFor='doctor_email'
            inputClassName='txt-field-input-medium'
            labelText='Email'
            labelClassName='section-label'
            placeholder='Optional'
            errorMsg={this.props.errors.doctorEmail}
            onChange={this.handleDoctorEmailChange}
            onBlur={this.handleDoctorEmailBlur}
            defaultValue={this.props.practice.doctorEmail}
          />
        </div>

        <ActionArea {...buttonProps} />

        <FillMe
          handleOnClick={this.handleFillMe}
          env={this.props.env}
        ></FillMe>

        { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

      </form>
    </section>;
  }
}

export default ContactInformation;

